import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { ButtonModule } from 'primeng/button';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ProgressBarModule } from 'primeng/progressbar';
import { TableModule } from 'primeng/table';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { CheckboxModule } from 'primeng/checkbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { ChartModule } from 'primeng/chart';
import { DrawerModule } from 'primeng/drawer';
import { RadioButtonModule } from 'primeng/radiobutton';
import { PasswordModule } from 'primeng/password';
import { MessageModule } from 'primeng/message';
// import { MessagesModule } from 'primeng/messages'; // Removed in PrimeNG v20 - p-messages merged into p-message
import { ToastModule } from 'primeng/toast';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { DragDropModule } from 'primeng/dragdrop';
import { ListboxModule } from 'primeng/listbox';
import { TreeModule } from 'primeng/tree';
import { AngularDraggableModule } from 'angular2-draggable';
import { AccordionModule } from 'primeng/accordion';
import { TreeTableModule } from 'primeng/treetable';
import { TabsModule } from 'primeng/tabs';
import { SplitButtonModule } from 'primeng/splitbutton';
// import { SpinnerModule } from 'primeng/spinner';
import { DatePickerModule } from 'primeng/datepicker';
import { BlockUIModule } from 'primeng/blockui';
import { PanelModule } from 'primeng/panel';
// import { Ng2PanZoomModule } from 'ng2-panzoom';
import { NgxPanZoomModule } from 'ngx-panzoom';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { EditorModule } from 'primeng/editor';
import { PopoverModule } from 'primeng/popover';
import { TranslateModule } from '@ngx-translate/core';
import { StepsModule } from 'primeng/steps';
import { InputMaskModule } from 'primeng/inputmask';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ScrollingModule } from '@angular/cdk/scrolling';
// import { NgxSkeletonLoaderModule } from 'p-skeleton';
// import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { ScrollerModule } from 'primeng/scroller';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { PickListModule } from 'primeng/picklist';
import { MenuModule } from 'primeng/menu';
import { InputNumberModule } from 'primeng/inputnumber';
import { SkeletonModule } from 'primeng/skeleton';
import { DialogComponent } from '../../dialog/dialog.component';
import { DevcieSharingComponent } from '../../device/devcie-sharing/devcie-sharing.component';
import { DisplaySourceTypeCodePipe } from '../../CustomPipe/device-sourcetype-code.pipe';
import { TrialLicenseCodePipe } from '../../CustomPipe/trial-license-code.pipe';
import { NumToDatePipe } from '../../CustomPipe/num-to-date';
import { NumToDaysPipe } from '../../CustomPipe/num-to-days';
import { SecToMinPipe } from '../../CustomPipe/sec-to-min.pipe';
import { UtcFormatPipe } from '../../CustomPipe/utc-format.pipe';
import { DeviceTypeCodePipe } from '../../CustomPipe/device-type-code.pipe';
import { HourOrDayPipe } from '../../CustomPipe/hour-or-day.pipe';
import { StatusHardwareFaultPipe } from '../../CustomPipe/status-hardware-fault.pipe';
import { TempSplitPipe } from '../../CustomPipe/temp-split.pipe';
import { HourToDayPipe } from '../../CustomPipe/hour-to-day.pipe';
import { StrToBoolPipe } from '../../CustomPipe/str-to-bool.pipe';
import { StatusEventPipe } from '../../CustomPipe/status-event.pipe';
import { StatusEventTranslatePipe } from '../../CustomPipe/status-event-translate.pipe';
import { CountdownComponent } from 'ngx-countdown';
import { HelpHeaderComponent } from '../../help/help-header/help-header.component';
import { HelpMenuComponent } from '../../help/help-menu/help-menu.component';
import { TwofactorSocialComponent } from '../../account/twofactor-social/twofactor-social.component';

@NgModule({
  imports: [
    CommonModule,
    LoadingBarRouterModule,
    ButtonModule,
    SelectButtonModule,
    FormsModule,
    ReactiveFormsModule,
    ProgressBarModule,
    TableModule,
    SelectModule,
    InputTextModule,
    TooltipModule,
    DialogModule,
    CheckboxModule,
    MultiSelectModule,
    ChartModule,
    DrawerModule,
    RadioButtonModule,
    PasswordModule,
    // MessagesModule, // Removed in PrimeNG v20
    MessageModule,
    // Ng2PanZoomModule,
    NgxPanZoomModule,
    OrganizationChartModule,
    EditorModule,
    PopoverModule,
    ScrollingModule,
    // NgxSkeletonLoaderModule,
    // VirtualScrollerModule,
    ScrollerModule,
    LazyLoadImageModule,
    PickListModule,
    CountdownComponent,
    TranslateModule,
    InputMaskModule,
    StepsModule,
    ToggleButtonModule,
    ToggleSwitchModule,
    ToastModule,
    ScrollPanelModule,
    DragDropModule,
    ListboxModule,
    TreeModule,
    AngularDraggableModule,
    AccordionModule,
    TreeTableModule,
    TabsModule,
    SplitButtonModule,
    // SpinnerModule,
    InputNumberModule,
    DatePickerModule,
    BlockUIModule,
    PanelModule,
    MenuModule,
    SkeletonModule
  ],
  exports: [
    CommonModule,
    LoadingBarRouterModule,
    ButtonModule,
    SelectButtonModule,
    FormsModule,
    ReactiveFormsModule,
    ProgressBarModule,
    TableModule,
    SelectModule,
    InputTextModule,
    TooltipModule,
    DialogModule,
    CheckboxModule,
    MultiSelectModule,
    ChartModule,
    DrawerModule,
    RadioButtonModule,
    PasswordModule,
    // MessagesModule, // Removed in PrimeNG v20
    MessageModule,
    ToastModule,
    ScrollPanelModule,
    DragDropModule,
    ListboxModule,
    TreeModule,
    AngularDraggableModule,
    AccordionModule,
    TreeTableModule,
    TabsModule,
    SplitButtonModule,
    // SpinnerModule,
    InputNumberModule,
    DatePickerModule,
    BlockUIModule,
    PanelModule,
    // Ng2PanZoomModule,
    NgxPanZoomModule,
    OrganizationChartModule,
    EditorModule,
    PopoverModule,
    TranslateModule,
    StepsModule,
    InputMaskModule,
    ToggleButtonModule,
    ToggleSwitchModule,
    ScrollingModule,
    // NgxSkeletonLoaderModule,
    // VirtualScrollerModule,
    LazyLoadImageModule,
    PickListModule,
    CountdownComponent,
    MenuModule,
    SkeletonModule,
    DialogComponent,
    DevcieSharingComponent,
    HelpHeaderComponent,
    HelpMenuComponent,
    TwofactorSocialComponent,
    DisplaySourceTypeCodePipe,
    TrialLicenseCodePipe,
    NumToDatePipe,
    NumToDaysPipe,
    SecToMinPipe,
    UtcFormatPipe,
    DeviceTypeCodePipe,
    HourOrDayPipe,
    StatusHardwareFaultPipe,
    TempSplitPipe,
    HourToDayPipe,
    StrToBoolPipe,
    StatusEventPipe,
    StatusEventTranslatePipe
  ],
  providers: [
  ],
  declarations: [
    DialogComponent,
    DevcieSharingComponent,
    HelpHeaderComponent,
    HelpMenuComponent,
    TwofactorSocialComponent,
    DisplaySourceTypeCodePipe,
    TrialLicenseCodePipe,
    NumToDatePipe,
    NumToDaysPipe,
    SecToMinPipe,
    UtcFormatPipe,
    DeviceTypeCodePipe,
    HourOrDayPipe,
    StatusHardwareFaultPipe,
    TempSplitPipe,
    HourToDayPipe,
    StrToBoolPipe,
    StatusEventPipe,
    StatusEventTranslatePipe
  ]
})
export class ShareModule { }
